// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Block, { BlockProps } from "@store/Library/Components/Toolkit/Block";
import { GridContainerProps } from "@store/MobiusOverrides/GridContainer/GridContainer";
import { GridItemProps } from "@store/MobiusOverrides/GridItem/GridItem";
import constants from "@store/constants";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const BlogSearch = getWidgetComponent("Blog/BlogSearch");
const BlogHeader = getWidgetComponent("Blog/BlogHeader");

const mapStateToProps = (state: ApplicationState) => ({
    page: getCurrentPage(state),
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface BlogPageViewStyles {
    containedWrapper?: BlockProps;
    blogHeaderContainer?: GridContainerProps;
    blogHeaderSearchGridItem?: GridItemProps;
    blogHeaderSubTitleGridItem?: GridItemProps;
    blogTitle: TypographyProps;
    blogPostTitle: TypographyProps;
    dateAndAuthorBlockWrapper?: InjectableCss;
    contentWrapper?: TypographyProps;
}

export const blogPageViewStyles: BlogPageViewStyles = {
    blogHeaderContainer: {
        gap: 15,
    },
    blogHeaderSearchGridItem: {
        width: [12, 6, 8, 6, 6],
    },
    blogHeaderSubTitleGridItem: {
        width: [12, 6, 4, 6, 6],
    },
    blogTitle: {
        variant: "h2",
        color: "primary",
    },
    blogPostTitle: {
        variant: "h1",
        color: "primary",
        css: css`
            text-align: center;
        `,
    },
    dateAndAuthorBlockWrapper: {
        css: css`
            background-color: ${getColor("common.accent")};
        `,
    },
    contentWrapper: {
        css: css`
            ${spacingStyles(pxToRem(8))}
            font-size: ${x => x.theme.design.typography.size.larger};
        `,
    },
};

const styles = blogPageViewStyles;

const BlogPageView = ({ page }: Props) => {
    if (!page) {
        return null;
    }

    const {
        fields: { title },
    } = page;

    return (
        <>
            <Block {...styles.containedWrapper}>
                <BlogHeader />
                {title && <Typography {...styles.blogPostTitle}>{title}</Typography>}
                <Zone contentId={page.id} zoneName="Social" />
            </Block>
            <Zone contentId={page.id} zoneName="Author" />
            <Zone contentId={page.id} zoneName="Content1" />
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(BlogPageView),
    definition: {
        group: constants.widgetGroup.blogPage,
        allowedContexts: [constants.widgetGroup.blogPage] as any,
    },
};

export default widgetModule;
